import { FdDbKeys } from "@fd/core";

enum AppDbKeys /* App specific db keys can be added here */ {}

export const DbKeys = { ...AppDbKeys, ...FdDbKeys };
